import React, { useEffect } from 'react';

import { useContext } from 'components/Users/Context';

import { ToastContainer, toast } from 'react-toastify';

export default function Index() {
  const { actions, dispatch, state } = useContext();

  useEffect(() => {
    actions.load(dispatch);
  }, []);

  useEffect(() => {
    if (state.user) {
      actions.loadNotifications((collection) => {
        collection.forEach((notification) => {
          toast.success(notification.description, {
            position: 'top-right',
            autoClose: false,
            closeOnClick: true,
            onClose: () => {
              actions.readNotification(notification);
            },
          });
        });
      });
    }
  }, [state.user]);

  return (
    <ToastContainer />
  );
}
